import { Injectable } from '@angular/core';
import { NavigationService } from '@core/services/navigation/navigation.service';
import { CommandAvailabilityService } from '@shared/services/command-availability.service';
import { BaseProductCommand } from '@shared/commands/base-product.command';
import { IProductCommandContext } from '@shared/models/command';
import { ProductTypes } from '@shared/models/products.model';
import { InvestmentApiService } from '@core/services/investment-api/investment-api.service';
import { AlertController } from '@ionic/angular';

@Injectable({ providedIn: 'root' })
export class WithdrawCommand extends BaseProductCommand {
  readonly type = 'withdraw';
  readonly title = 'Вывести';
  readonly icon = 'forward';
  readonly productType = ProductTypes.ACCOUNT;
  readonly isInfoAction = false;
  readonly settingsNames = ['PAY/SELF_FREE'];
  readonly order = 3; // Третий в actions для account

  constructor(
    private navigationService: NavigationService,
    private investmentApiService: InvestmentApiService,
    private alertCtrl: AlertController,
    commandAvailabilityService: CommandAvailabilityService
  ) {
    super(commandAvailabilityService);
  }

  async execute(context: IProductCommandContext): Promise<void> {
    try {
      const isIISBrokerageProduct = await this.investmentApiService.isIISBrokerageProduct(context.data);

      if (isIISBrokerageProduct) {
        const alert = await this.alertCtrl.create({
          message: 'Уважаемый клиент, для вывода денежных средств с ИИС обратитесь в Банк по телефону (495) 727-9797 добавочный 53-20',
          buttons: [{ text: 'Ок', role: 'cancel' }],
        });

        await alert.present();
      } else {
        await this.navigationService.push('payments/withdrawal-order', {
          state: { debitAccount: context.data }
        });
      }
    } catch (error) {
      console.error('Error:', error);
    }
  }

  protected checkAdditionalAvailability(context: IProductCommandContext): boolean {
    return !!context.data.isBrokerAccount;
  }
}
